<div fxLayout="column" id="login-page" >

  <div fxFlex="25" fxLayout="row" fxLayoutAlign="center stretch" class="header-container">
    <div class="logo"></div>
  </div>
  
  <div fxFlex="70" class="login-form">
    <mat-card>
      <mat-card-content>
        <div class="custom-title">
          <h2>ログイン</h2>
          <div class="title-underline"></div>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" #f="ngForm" autocomplete="off" (keyup.enter)="onSubmit()">
          <formly-form
            [form]="form" 
            [model]="model" 
            [fields]="fields">
          
          </formly-form>

          <mat-slide-toggle class="slide-toggle" formControlName="rememberMe">
            ログインを保持
          </mat-slide-toggle>

          <div fxLayout="column" fxLayoutAlign="center center">
            <button type="submit" mat-icon-button (click)="f.onSubmit(model)">
              <mat-icon class="login-btn-icon"></mat-icon>
            </button>
          </div>
      
        </form>

      </mat-card-content>
    </mat-card>
  
  </div>
</div>

